// extracted by mini-css-extract-plugin
module.exports = {"loadingSkeleton":"index-module_loadingSkeleton_18_4Y","loading":"index-module_loading_3xC_V"};